import { render, staticRenderFns } from "./MainRuleModal.vue?vue&type=template&id=3ada94d3&"
import script from "./MainRuleModal.vue?vue&type=script&lang=js&"
export * from "./MainRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./MainRuleModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports